/** @jsxImportSource @emotion/react */

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTypedSelector } from '@hook/common/useStore';
import PageTemplate from '@page/iyagigo/page-template';
import { INVALID_URL } from '@constant/error';
import { EWorkbookStudyType, TIyagigoSubMenu } from '@datatype/iyagigo/type';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import ClozeNote from '@component/iyagigo/cloze/note';

const ClozeNotePage: React.FC = () => {
  // ############### route ###############
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const languagePath = searchParams.get('language');
  const subjectPath = searchParams.get('subject') as TIyagigoSubMenu['cloze'];
  if (!languagePath && !subjectPath) throw new Error(INVALID_URL);

  // ############### state ###############
  const workbookStudyType =
    useTypedSelector((state) => state.rootReducer?.workbookReducer?.workbookStudyType) ?? EWorkbookStudyType.BOOKMARK_NOTE;

  return (
    <PageTemplate
      title={workbookStudyType === EWorkbookStudyType.INCORRECT_NOTE ? '틀린 문제' : '저장한 문제'}
      mode='back'
      handleNavigationClick={() => navigate(IYAGIGO_PATH.CLOZE_HOME_PATH)}>
      <ClozeNote />
    </PageTemplate>
  );
};

export default ClozeNotePage;
